interface LentalsLogoProps {
  /** Size variant */
  size?: 'sm' | 'md' | 'lg'
  /** Use dark colors (for light backgrounds) - default true */
  dark?: boolean
}

const SIZES = {
  sm: { fontSize: '20px', dotSize: 5 },
  md: { fontSize: '28px', dotSize: 7 },
  lg: { fontSize: '40px', dotSize: 10 },
}

/**
 * Lentals wordmark logo
 * Design: Sora font wordmark with copper dot
 */
export default function LentalsLogo({ size = 'md', dark = true }: LentalsLogoProps) {
  const { fontSize, dotSize } = SIZES[size]
  const textColor = dark ? '#1a2744' : '#ffffff'
  const copperColor = dark ? '#c87941' : '#d4956b'

  return (
    <div className="flex items-center" aria-label="Lentals">
      <span
        style={{
          fontFamily: "'Sora', sans-serif",
          fontSize,
          fontWeight: 700,
          color: textColor,
          letterSpacing: '-1px',
          lineHeight: 1,
        }}
      >
        lentals
        <span
          style={{
            display: 'inline-block',
            width: dotSize,
            height: dotSize,
            background: copperColor,
            borderRadius: '50%',
            marginLeft: 3,
            verticalAlign: 'middle',
          }}
        />
      </span>
    </div>
  )
}
